import { Component, OnDestroy, OnInit } from "@angular/core";
import { IntegratedAdmissionAppointment } from "src/app/model/integrated-admission/integrated-admission-appointment";
import { IntegratedAdmissionWizardService } from "../../service/integrated-admission-wizard.service";
import { IntegratedAdmissionAppointmentValidation } from "src/app/model/integrated-admission/integrated-admission-appointment-validation";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Subscription } from "rxjs";
import { IConfig } from "ngx-mask";
import { MatDialog } from "@angular/material";
import { IntegratedAdmissionAppointmentValidationDialogComponent } from "./integrated-admission-appointment-validation-dialog/integrated-admission-appointment-validation-dialog.component";
import { MedicalAppointmentValidationProcedure } from "src/app/model/medical-appointment-validation-procedure";

@Component({
  selector: "app-integrated-admission-appointment-validation",
  templateUrl: "./integrated-admission-appointment-validation.component.html",
  styleUrls: ["./integrated-admission-appointment-validation.component.css"],
})
export class IntegratedAdmissionAppointmentValidationComponent
  implements OnInit, OnDestroy
{
  validationSubscriptions: Subscription;
  readonlySubscriptions: Subscription;

  planSubscriptions: Subscription;
  varlidation: IntegratedAdmissionAppointmentValidation;
  validityDays = "";
  athorizationValidity: boolean;
  form: FormGroup;
  lodading = false;
  readonly = false;
  isPreadmission = false;

  showValidationProceduresButton: boolean = true;

  mask: string = "";
  showMaskTyped: boolean;

  constructor(
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private service: IntegratedAdmissionWizardService,
  ) {
    this.form = this.formBuilder.group({
      CredentialNumber: [""],
      Code: [""],
      PreAuth: [""],
      ReferringPhysician: [""],
      ReferringPhysicianInstitute: [""],
      PrescriptionDate: [""],
      RequiredCIEDiagnosis: [false],
      DiagnosisCodeMode: [""],
      RequiredValidation: [""],
      RequiredCode: [""],
      RequiredCredentialNumber: [""],
      RequiredPreAuth: [false],
      MedicalAppointmentValidation: [null],
      AuthorizationNumber: [null],
      InvalidOnError: [null],
      InvalidOnRegister: [null],
      InvalidOnVerification: [null],
      IsRegister: [null],
      IsVerification: [null],
      HasError: [null],
    });
  }

  get formattedPhoneNumber(): string {
    return this.form.get("CredentialNumber")
      ? this.form.get("CredentialNumber").value
      : "";
  }

  ngOnDestroy(): void {
    if (this.validationSubscriptions)
      this.validationSubscriptions.unsubscribe();
    if (this.planSubscriptions) this.planSubscriptions.unsubscribe();

    if (this.readonlySubscriptions) this.readonlySubscriptions.unsubscribe();
  }

  ngOnInit() {
    this.isPreadmission = this.service.isPreadmission();

    this.readonlySubscriptions = this.service.currentReadOnlySubject$.subscribe(
      (readonly) => {
        this.readonly = readonly;
        if (this.readonly) {
          this.form.disable();
        }
      },
    );

    this.validationSubscriptions =
      this.service.currentValidationSubject$.subscribe((validation) => {

        this.varlidation = validation;

        this.mask = this.varlidation.Mask;
        this.showMaskTyped = true;

        this.form.patchValue(
          {
            CredentialNumber: this.varlidation.CredentialNumber,
            Code: this.varlidation.Code,
            PreAuth: this.varlidation.PreAuth,
            ReferringPhysician: this.varlidation.ReferringPhysician,
            ReferringPhysicianInstitute:
              this.varlidation.ReferringPhysicianInstitute,
            PrescriptionDate: this.varlidation.PrescriptionDate,
            RequiredCIEDiagnosis: this.varlidation.RequiredCIEDiagnosis,
            DiagnosisCodeMode: this.varlidation.DiagnosisCodeMode,
            RequiredValidation: this.varlidation.RequiredValidation,
            RequiredCode: this.varlidation.RequiredCode,
            RequiredPreAuth: this.varlidation.RequiredPreAuth,
            RequiredCredentialNumber: this.varlidation.RequiredCredentialNumber,
            AuthorizationNumber: this.varlidation.AuthorizationNumber,
            MedicalAppointmentValidation:
              this.varlidation.MedicalAppointmentValidation,
            InvalidOnError: this.varlidation.InvalidOnError,
            InvalidOnRegister: this.varlidation.InvalidOnRegister,
            InvalidOnVerification: this.varlidation.InvalidOnVerification,
            IsRegister: this.varlidation.IsRegister,
            IsVerification: this.varlidation.IsVerification,
            HasError: this.varlidation.HasError,
          },
          { emitEvent: false },
        );

        this.service.setValidation(this.form.value);
      });

    this.planSubscriptions = this.service.currentPlanSubject$.subscribe(
      (plan) => {
        if (plan && plan.Entity) {
          const entity = plan.Entity;

          this.showValidationProceduresButton = entity.ShowValidation;

          this.athorizationValidity = entity.AthorizationValidity;

          if (this.athorizationValidity) {
            this.validityDays = "(" + entity.AthorizationValidityDay + ")";
          } else {
            this.validityDays = "(" + entity.MedicalOrderValidityDay + ")";
          }
        }
      },
    );

    this.form.valueChanges.subscribe((value) => {
      this.service.setValidation(value);
    });
  }

  get needCancel(): boolean {
    return this.varlidation.MedicalAppointmentValidation
      ? this.varlidation.MedicalAppointmentValidation.NeedCancel
      : false;
  }

  procedures: MedicalAppointmentValidationProcedure[] = [];

  procedureAggregateRequired(): boolean {
    if (this.service.proceduresGroupedRequired) {
      this.service.notificationToastService.info(
        "Primero debe desagrupar las prácticas para validar.",
        "Validación",
      );
      return true;
    } else {
      return false;
    }
  }

  async showValidationProcedures() {
    try {
      if (this.procedureAggregateRequired()) {
        return;
      }
      this.lodading = true;

      const previewsProcedures = [...this.procedures];
      this.procedures = await this.service.getValidationProcedures();

      const dia = this.dialog.open(
        IntegratedAdmissionAppointmentValidationDialogComponent,
        {
          width: "50%",
          data: {
            authorizationNumber: this.form.get("AuthorizationNumber").value,
            previewsProcedures: previewsProcedures,
            procedures: this.procedures,
            isPreadmission: this.isPreadmission
          },
        },
      );

      dia.afterClosed().subscribe((value) => {
        this.form.patchValue(
          {
            AuthorizationNumber: value.authorizationNumber,
          },
          { emitEvent: false },
        );
        this.service.loadProceduresForValidation(value.procedures || []);
        this.service.setValidation(this.form.value);
      });
    } finally {
      this.lodading = false;
    }
  }

  async executeValidation() {
    try {
      if (this.procedureAggregateRequired()) {
        return;
      }

      this.lodading = true;
      const validationInfo = await this.service.executeValidation();

      const result = validationInfo.Result;
      if (validationInfo && validationInfo.MedicalAppointmentValidation) {
        const validation = validationInfo.MedicalAppointmentValidation;

        const authorizationNumber = this.form.get("AuthorizationNumber").value;

        this.varlidation.AuthorizationNumber =
          validation && !validation.NoValidate && validation.NeedCancel
            ? validation.AuthorizationNumber
              ? validation.AuthorizationNumber
              : validation.ReferenceNumber
            : authorizationNumber;

        this.form.patchValue(
          {
            MedicalAppointmentValidation: validation,
            AuthorizationNumber: this.varlidation.AuthorizationNumber,
          },
          { emitEvent: false },
        );

        const dialog = this.dialog.open(
          IntegratedAdmissionAppointmentValidationDialogComponent,
          {
            width: "50%",
            data: {
              validation: result,
              procedures: result.Procedures,
            },
          },
        );
      }
    } finally {
      this.lodading = false;
    }
  }
}
